import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { usePostHogTracking } from '../hooks/usePostHogTracking';

export const CallbackPage: React.FC = () => {
  const { error, isLoading, isAuthenticated, user } = useAuth0();
  const { identifyUser, trackEvent } = usePostHogTracking();
  const [hasTracked, setHasTracked] = useState(false);

  // Track PostHog events but DON'T redirect - let Auth0's onRedirectCallback handle that
  useEffect(() => {
    const trackUser = async () => {
      if (isAuthenticated && !isLoading && user && !hasTracked) {
        setHasTracked(true);
        
        // Identify the user in PostHog
        identifyUser();
        
        // Track successful login
        trackEvent('user_login_completed', {
          login_method: 'auth0',
          user_email: user.email,
          user_name: user.name
        });
        
        // Note: Redirect is handled by onRedirectCallback in Auth0Provider
        // This ensures proper onboarding status check before navigation
      }
    };

    trackUser();
  }, [isAuthenticated, isLoading, user, hasTracked, identifyUser, trackEvent]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-red-50">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6">
          <div className="flex items-center justify-center w-12 h-12 mx-auto bg-red-100 rounded-full mb-4">
            <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-gray-900 text-center mb-2">Authentication Failed</h2>
          <p className="text-gray-600 text-center mb-4">{error.message}</p>
          <button
            onClick={() => window.location.href = '/'}
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Return to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-blue-50">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Completing Authentication...</h2>
        <p className="text-gray-600">Please wait while we log you in</p>
      </div>
    </div>
  );
};
